import { render } from "./GiftView.vue?vue&type=template&id=7ee586b1"
import script from "./GiftView.vue?vue&type=script&lang=js"
export * from "./GiftView.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__